import React from 'react';
import { Building } from '../../../../../types/protocols';
import { ComponentLifetime, TemplatesByType } from '../../../TemplatesEditor/types';
import type { MaintenanceDraftWithDone } from '../../types';
import type { MaintenancePlan } from '../../../types';
import type { PlanDiff } from '../../utils/planDiff';
import { DraftPreviewTabs } from '../ui/DraftPreviewTabs';
import './DraftPreviewModal.css';

interface DraftPreviewModalProps {
    building: Building;
    maintenanceDraft: MaintenanceDraftWithDone;
    componentLifetimes: Record<string, ComponentLifetime>;
    maintenanceTemplates: TemplatesByType;
    onClose: () => void;
    activePlan?: MaintenancePlan | null;
    diff: PlanDiff | null;
    yearsToShow: number;
    onYearsToShowChange: (years: number) => void;
    /** Selecting a component in the diff closes the modal on it */
    onSelectComponent?: (componentKey: string) => void;
}

/**
 * Full-screen preview modal for MaintenanceDraft.
 * Wraps the preview (and, with an active plan, the diff tab) with a modal backdrop and close button.
 */
export const DraftPreviewModal: React.FC<DraftPreviewModalProps> = ({
    building,
    maintenanceDraft,
    componentLifetimes,
    maintenanceTemplates,
    onClose,
    activePlan,
    diff,
    yearsToShow,
    onYearsToShowChange,
    onSelectComponent
}) => {
    return (
        <div
            className="draft-preview-modal-backdrop"
            onMouseDown={(e) => {
                if (e.target === e.currentTarget) {
                    onClose();
                }
            }}
        >
            <div className="draft-preview-modal">
                {/* Modal-specific header with close button */}
                <div className="draft-preview-modal-close-row">
                    <button
                        type="button"
                        className="btn-close"
                        onClick={onClose}
                        aria-label="Stäng"
                    />
                </div>

                <DraftPreviewTabs
                    building={building}
                    maintenanceDraft={maintenanceDraft}
                    componentLifetimes={componentLifetimes}
                    maintenanceTemplates={maintenanceTemplates}
                    showHeader={true}
                    activePlan={activePlan}
                    diff={diff}
                    yearsToShow={yearsToShow}
                    onYearsToShowChange={onYearsToShowChange}
                    onSelectComponent={onSelectComponent && (key => {
                        onSelectComponent(key);
                        onClose();
                    })}
                />
            </div>
        </div>
    );
};
